import { Message as ChatMessage } from '@chatscope/chat-ui-kit-react';

import type { Message } from '../types';
import { LinkifiedText } from '../lib/linkify';
import { AttachmentImage } from './AttachmentImage';
import { QuotedBroadcastPreview } from './QuotedBroadcastPreview';

interface MessageBubbleProps {
  message: Message;
  currentUserId: string | number;
  senderLabel: string;
  time: string;
}

export function MessageBubble({
  message,
  currentUserId,
  senderLabel,
  time,
}: MessageBubbleProps) {
  const isOutgoing =
    message.sender_id != null &&
    Number(message.sender_id) === Number(currentUserId);
  const inReplyToBroadcastId = message.metadata?.in_reply_to_broadcast_id as
    | string
    | undefined;

  return (
    <ChatMessage
      model={{
        message: message.content ?? '',
        sentTime: message.created_at,
        sender: senderLabel,
        direction: isOutgoing ? 1 : 0,
        position: 'single',
        type: 'custom',
      }}
    >
      <ChatMessage.CustomContent>
        <div style={{ fontWeight: 600, fontSize: 13 }}>{senderLabel}</div>
        {inReplyToBroadcastId ? (
          <QuotedBroadcastPreview broadcastId={inReplyToBroadcastId} />
        ) : null}
        {message.attachments?.length
          ? message.attachments.map((att) => (
              <div key={att.id} style={{ marginTop: 6 }}>
                <AttachmentImage
                  storagePath={att.storage_path}
                  alt={att.file_name ?? 'attachment'}
                />
              </div>
            ))
          : null}
        {message.content ? (
          <div style={{ marginTop: 6 }}>
            <LinkifiedText text={message.content} />
          </div>
        ) : null}
        <div
          style={{
            float: 'right',
            paddingTop: 4,
            fontSize: 11,
            opacity: 0.7,
          }}
        >
          {time}
        </div>
      </ChatMessage.CustomContent>
    </ChatMessage>
  );
}
